/**
 * Created by JIA on 2022/1/20.
 */

//region SingSound Result Process

import _ from "lodash";
import * as Helper from "../../../../utils/Helper";
import DebugLogger from "../../../../utils/DebugLogger";
import AppConfig from "../../../../config/AppConfig";
import { t } from "../../../../i18n";
import { AzureEnums, i18nKey, IsTheERCase } from "../SpeechCommonHelper";

/**
 * 尝试将传入的文本和拼音组装成讯飞支持的注音题目格式
 *  https://www.xfyun.cn/doc/Ise/IseAPI.html#%E8%AF%95%E9%A2%98%E6%A0%BC%E5%BC%8F%E8%AF%B4%E6%98%8E
 * <customizer: interphonic>
 * 今天天气怎么样
 * jin1|tian1|tian1|qi4|zen3|me5|yang4
 * @param interObj
 * @param nativeSetReferenceText
 */
const handleTextForSingSound = (interObj, nativeSetReferenceText) => {
    const { syllableArray, referenceText } = interObj;
    let referenceSyllableArray = syllableArray;
    let referenceSyllableArrayValid = referenceSyllableArray && referenceText && _.isArray(referenceSyllableArray) && referenceSyllableArray.length === referenceText.length;
    if (referenceSyllableArrayValid) {
        let finalText = "";
        let punctuationArr = [];
        //获取参考答案的拼音
        let newReferenceSyllableArray = [];
        let ERIndexArray = []; //保存 儿化音case 儿的index
        const zReferenceTextArr = _.map(referenceText, (s, index) => {
            if (Helper.isPunctuation(s)) {
                punctuationArr.push({
                    letter: s,
                    index: index,
                });
                return "";
            }
            if (referenceSyllableArrayValid) {
                newReferenceSyllableArray.push(referenceSyllableArray[index]);

                if (index > 0) {
                    const lastChar = referenceText[index - 1];
                    if (!Helper.isPunctuation(lastChar)) {
                        const nowSyllableArrLength = newReferenceSyllableArray.length;
                        const isTheERCase = IsTheERCase(referenceText[index - 1], s, newReferenceSyllableArray[nowSyllableArrLength - 2], newReferenceSyllableArray[nowSyllableArrLength - 1]);
                        if (isTheERCase) {
                            //儿化音case, 回退本字和上一个字
                            newReferenceSyllableArray[nowSyllableArrLength - 2] = newReferenceSyllableArray[nowSyllableArrLength - 2].slice(0, -1);
                            newReferenceSyllableArray[nowSyllableArrLength - 1] = "er5";
                            ERIndexArray.push(nowSyllableArrLength - 1);
                        }
                    }
                }
            }
            return s;
        });
        _.each(zReferenceTextArr, (item, index) => {
            finalText += `${item}(${normalizePinyinForSingSound(newReferenceSyllableArray[index])})`;
        });
        DebugLogger.log(finalText);
        nativeSetReferenceText(finalText);
    }
};

//拼音需是字典中正确的拼音，调型在0-9之间取值，其中0/5/6/7/8/9均代表轻声。
//为没有调形的添加5
const normalizePinyinForSingSound = pinyinz => {
    if (_.isString(pinyinz) && pinyinz.length > 0) {
        //讯飞不认识ü的拼音, 替换成v
        const zPinyin = _.replace(pinyinz, "ü", "v");
        const lastChar = pinyinz[zPinyin.length - 1];
        if (/[\d]/gi.test(lastChar)) {
            return zPinyin;
        } else {
            return `${zPinyin}0`;
        }
    }

    return "";
};

const handleSingSoundResult = (internalInfoObj, jsonResult) => {
    //https://pt.singsound.com:10081/singsound-public/SingsoundGinger/-/wikis/HTTP-POST-API-%E6%8E%A5%E5%85%A5%E6%96%87%E6%A1%A3
    //first see if request is success or not
    //Please Note the return obj prop is first letter upper case
    let returnObj = {
        shouldResolve: false,
        rejectMessage: "",
        result: {},
    };
    let notCompleted = true;
    const realResult = jsonResult;
    if (realResult) {
        let newReturnObj = {
            passed: false,
            resultWordArray: [],
            referenceTextWordArray: [],
            pronScore: 0,
            accuracyScore: 0,
            fluencyScore: 0,
            completionScore: 0,
            wordResultArray: [],
            notPassedWordIndexDic: {}, // the key is index, the value is word item
            rawResult: jsonResult,
        };

        newReturnObj.passed = realResult.overall > 80;
        newReturnObj.resultWordArray = []; //should we compare this?
        newReturnObj.referenceTextWordArray = internalInfoObj.referenceText.split("");
        newReturnObj.pronScore = realResult.pron;
        newReturnObj.accuracyScore = realResult.overall;
        newReturnObj.fluencyScore = realResult.fluency.overall;
        newReturnObj.completionScore = realResult.integrity;
        newReturnObj.errorType = "";
        let passedWordCount = 0;
        if (AppConfig.SPEECH_RECOGNIZE_SING_SOUND_RESULT_TYPE === 1 && realResult.details && _.isArray(realResult.details) && realResult.details.length > 0) {
            //go for inner
            _.each(realResult.details, (item, index) => {
                //{
                //         "pron": 39,
                //         "dur": 180,
                //         "chn_char": "你",
                //         "phn": 37,
                //         "overall": 39,
                //         "tone": 3,
                //         "score": 39,
                //         "char": "ni",
                //         "tonescore": 54,
                //         "phone": [
                //           {
                //             "char": "n",
                //             "score": 33,
                //             "end": 730,
                //             "start": 690
                //           },
                //           {
                //             "char": "i",
                //             "score": 42,
                //             "end": 750,
                //             "start": 730
                //           }
                //         ],
                //         "fluency": 100
                //       },

                let syllablesResult = [];
                let yun = "";
                let m = "";
                _.each(item.phone, phone => {
                    const isYun = !_.startsWith(item.char, phone.char);
                    if (isYun) {
                        yun = phone.char;
                    } else {
                        m = phone.char;
                    }
                    let flag = phone.score >= 60;
                    if (isYun && item.tonescore < 60) {
                        flag = false;
                    }
                    syllablesResult.push({
                        content: phone.char,
                        isYun: isYun ? "1" : "0",
                        dpMessage: "",
                        flag: flag,
                        monoTone: !isYun ? item.tone : "",
                        pErrMsg: "",
                        score: phone.score,
                    });
                });
                newReturnObj.wordResultArray.push({
                    word: item.chn_char,
                    pronScore: item.pron,
                    accuracyScore: item.score,
                    errorType: item.score >= 60 ? AzureEnums.WordErrorType.None : AzureEnums.WordErrorType.Mispronunciation,
                    phonemes: item.char, //just copy here
                    tone: item.tone, //just copy here
                    syllables: syllablesResult,
                    splitPinYinYun: {
                        wordPinYin: item.char,
                        mPinyin: m,
                        yunPinyin: yun,
                    },
                });
                if (item.overall >= 60) {
                    passedWordCount += 1;
                }
            });
        }
        //we will check the final pass word count and see if you are passed
        newReturnObj.passed = realResult.overall >= 60 && passedWordCount === newReturnObj.wordResultArray.length;
        newReturnObj.passedWordCount = passedWordCount;
        newReturnObj.wholeWordCount = newReturnObj.wordResultArray.length;

        //DebugLogger.log(newReturnObj);
        returnObj.result = newReturnObj;
        returnObj.shouldResolve = true;
        notCompleted = false;
    }
    if (notCompleted) {
        returnObj.shouldResolve = false;
        returnObj.rejectMessage = t(`${i18nKey}:ServerError`);
    }
    return returnObj;
};

//endregion
export { handleSingSoundResult, handleTextForSingSound };
